<template>
  <div class="filter-market-tabs" no-body>
    <tabsLayout>
      <b-tabs
        active-nav-item-class="font-weight-bold"
        content-class="my-0"
        card
        lazy
      >
        <!-- <b-tab
          v-for="tab of tabs"
          :key="tab.key"
          @click="currentTab = tab.key"
          :title="tab.label"
        >
          <component :is="currentTabComponent"></component>
        </b-tab> -->
        <b-tab class="px-0" title="依條件">
          <listLayout>
            <filter-by-rate />
          </listLayout>
        </b-tab>
      </b-tabs>
    </tabsLayout>
  </div>
</template>

<script>
import FilterByRate from "@/components/FilterByRate/FilterByRate.vue";
import tabsLayout from "@/layout/TabsLayout.vue";
import listLayout from "@/layout/ListLayout.vue";
// import FilterByLevel from "@/components/FilterByLevel/FilterByLevel.vue";

export default {
  name: "FilterMarketTabs",
  components: {
    FilterByRate,
    tabsLayout,
    listLayout
    // FilterByLevel
  },
  data() {
    return {
      // currentTab: "filter-by-rate",
      // tabs: [
      //   {
      //     key: "filter-by-rate",
      //     label: "依條件"
      //   },
      //   {
      //     key: "filter-by-level",
      //     label: "依等級"
      //   }
      // ]
    };
  }
  // computed: {
  //   currentTabComponent() {
  //     return this.currentTab;
  //   }
  // }
};
</script>

<style lang="scss" scoped></style>
